import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/storage";

let config = {
  apiKey: "AIzaSyBuCdPeDS-dUKnRspdB_DmmOS2XkoEj2ZY",
  authDomain: "hexa-saneamento.firebaseapp.com",
  databaseURL: "https://hexa-saneamento-default-rtdb.firebaseio.com",
  projectId: "hexa-saneamento",
  storageBucket: "hexa-saneameno.appspot.com",
  messagingSenderId: "977873837238",
  appId: "1:977873837238:web:280aa18a8dbcd399fc9a17",
  measurementId: "G-KD38BYSQ1J",
};

if (process.env.NODE_ENV === "development") {
  config = {
    apiKey: "AIzaSyA93sNVoiDm6GI1UAPbo3j9bjQBh31eVB0",
    authDomain: "hexa-saneamento-developer.firebaseapp.com",
    databaseURL: "https://hexa-saneamento-developer-default-rtdb.firebaseio.com",
    projectId: "hexa-saneamento-developer",
    storageBucket: "hexa-saneamento-developer.firebasestorage.app",
    messagingSenderId: "883285711875",
    appId: "1:883285711875:web:e614e2b78f0d12bd610236",
    measurementId: "G-8KG599THT9",
  };
}

firebase.initializeApp(config);

export default firebase;
